import React from 'react';
import { Card, CardContent } from './ui/card';
import { RadioGroup, RadioGroupItem } from './ui/radio-group';
import { Label } from './ui/label';
import { Fence, DoorOpen, LayoutGrid } from 'lucide-react';

const ConfigurationType = ({ selectedModel, configurationType, onConfigurationTypeChange }) => {
  if (!selectedModel) return null;

  return (
    <Card className="transition-all duration-300 hover:shadow-lg bg-gradient-to-r from-emerald-50 to-teal-50 border-2 border-emerald-200">
      <CardContent className="pt-6">
        <RadioGroup value={configurationType} onValueChange={onConfigurationTypeChange}>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className={`p-4 rounded-lg border-2 cursor-pointer transition-all ${ 
              configurationType === 'fence-only' 
                ? 'border-emerald-500 bg-white shadow-md' 
                : 'border-gray-200 hover:border-emerald-300 bg-white/50'
            }`}>
              <div className="flex items-start space-x-3">
                <RadioGroupItem value="fence-only" id="fence-only" />
                <Label htmlFor="fence-only" className="flex-1 cursor-pointer">
                  <div className="flex items-center gap-2 font-semibold text-gray-900">
                    <Fence className="w-5 h-5 text-emerald-600" />
                    Nur Zaun
                  </div>
                  <p className="text-sm text-gray-600 mt-1">
                    Konfigurieren Sie nur Zaunelemente
                  </p>
                </Label>
              </div>
            </div>

            <div className={`p-4 rounded-lg border-2 cursor-pointer transition-all ${ 
              configurationType === 'gates-only' 
                ? 'border-emerald-500 bg-white shadow-md' 
                : 'border-gray-200 hover:border-emerald-300 bg-white/50'
            }`}>
              <div className="flex items-start space-x-3">
                <RadioGroupItem value="gates-only" id="gates-only" />
                <Label htmlFor="gates-only" className="flex-1 cursor-pointer">
                  <div className="flex items-center gap-2 font-semibold text-gray-900">
                    <DoorOpen className="w-5 h-5 text-emerald-600" />
                    Nur Tore
                  </div>
                  <p className="text-sm text-gray-600 mt-1">
                    Konfigurieren Sie nur Toranlagen
                  </p>
                </Label>
              </div>
            </div>

            <div className={`p-4 rounded-lg border-2 cursor-pointer transition-all ${ 
              configurationType === 'fence-and-gates' 
                ? 'border-emerald-500 bg-white shadow-md' 
                : 'border-gray-200 hover:border-emerald-300 bg-white/50'
            }`}>
              <div className="flex items-start space-x-3">
                <RadioGroupItem value="fence-and-gates" id="fence-and-gates" />
                <Label htmlFor="fence-and-gates" className="flex-1 cursor-pointer">
                  <div className="flex items-center gap-2 font-semibold text-gray-900">
                    <LayoutGrid className="w-5 h-5 text-emerald-600" />
                    Zaun + Tore
                  </div>
                  <p className="text-sm text-gray-600 mt-1">
                    Komplettpaket mit Zaun und Toren
                  </p>
                </Label>
              </div>
            </div>
          </div>
        </RadioGroup>
      </CardContent>
    </Card>
  );
};

export default ConfigurationType;
